/**
 * @author        joseph.murphy@zumper.com (murph)
 * @copyright     Copyright (c) 2023, Zumper
 */

// TODO: confirm with product actual tracking events (they possibly wont change)
// we may not use these exact events so this file is meant more as a placeholder for now.
// was told to keep it.

import { trackGAEvent } from '@zcode/nr-utils'
import { COLLAGE } from '@zcode/nr/es/shared/constants/analytics'

export const mediaBarTracking = {
  trackOnImagesClick: () => trackGAEvent(COLLAGE, 'View Images'),
  trackOnVideosClick: () => trackGAEvent(COLLAGE, 'View Videos'),
  trackOnToursClick: () => trackGAEvent(COLLAGE, 'View Tours'),
  trackOnReelsClick: () => trackGAEvent(COLLAGE, 'View Reels'),
  trackOnViewAllClick: () => trackGAEvent(COLLAGE, 'View'),
}
